import CvDeliveryHistory from './components/CvDeliveryHistory';
import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import RegisterPage from "./pages/RegisterPage";
import BibliothequePage from "./pages/BibliothequePage";
import FacturesPage from "./pages/FacturesPage";
import FreelanceInvoicesPage from "./pages/facture/FreelanceInvoicesPage";
import ClientsPage from "./pages/ClientsPage";
import DevisPage from "./pages/DevisPage";
import GestionActivitePage from "./pages/GestionActivitePage";
import CandidatsPage from "./pages/CandidatsPage";
import AbsencesPage from "./pages/candidate/AbsencesPage";
import AcomptesPage from "./pages/candidate/AcomptesPage";
import DocumentsPerimesPage from "./pages/candidate/DocumentsPerimesPage";
import CommandesPage from "./pages/commandes/CommandesPage";
import MonComptePage from "./pages/MonComptePage";
import SwitcherAgencePage from "./pages/SwitcherAgencePage";
import MentionsLegales from "./pages/MentionsLegales";
import Politique from "./pages/Politique";
import AppLayout from "./pages/AppLayout";
import Contact from "./pages/Contact";
import NouvelleFacture from "./pages/NouvelleFacture";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ContratPage from "./pages/contract/ContractPage";
import Annonces from "./pages/annonces/Annonces3";
import RelevesHeures from "./pages/rh/ReleveHeures";
import RelevesHeuresListe from "./pages/rh/RelevesHeuresListe";
import RegistrePersonnel from "./pages/rh/RegistrePersonnel";
import PlanningPage from "./pages/rh/PlanningPage";
import AtradiusPage from "./pages/AtradiusPage";
import ProlongationsPage from "./pages/contract/ProlongationsPage";
import TestModalCandidat from "./components/TestModalCandidat";

function App() {
  return (
    <Routes>
      <Route path="/contact" element={<Contact />} />

      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/:token" element={<LoginPage />} />
      <Route path="/RegisterPage" element={<RegisterPage />} />

      <Route path="/switcherAgence" element={<SwitcherAgencePage />} />
      <Route path="/mentions" element={<MentionsLegales />} />

      <Route path="/politique" element={<Politique />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />

      <Route path="" element={<AppLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/actions-commerciales" element={<GestionActivitePage key="commercial" />} />
        <Route path="/devis" element={<DevisPage />} />
        <Route path="/atradius" element={<AtradiusPage />} />
        <Route path="/bibliotheque" element={<BibliothequePage />} />
        <Route path="/facture" element={<FacturesPage />} />
        <Route path="/mes-factures" element={<FreelanceInvoicesPage />} />
        <Route path="/candidats-proposes" element={<CvDeliveryHistory />} />
        <Route path="/candidatsPage" element={<CandidatsPage />} />
        <Route path="/absences" element={<AbsencesPage />} />
        <Route path="/acomptes" element={<AcomptesPage />} />
        <Route path="/documents-perimes" element={<DocumentsPerimesPage />} />
        <Route path="/commandesPage" element={<CommandesPage />} />
        <Route path="/actions-et-taches" element={<GestionActivitePage />} />
        <Route path="/gestionDesTaches" element={<GestionActivitePage key="tasks" initialTab="tasks" />} />
        <Route path="/nouvelleFacture" element={<NouvelleFacture />} />
        <Route path="/annonces" element={<Annonces />} />
        <Route path="/monCompte" element={<MonComptePage />} />
        <Route path="/contrats" element={<ContratPage />} />
        <Route path="/prolongations" element={<ProlongationsPage />} />
        <Route path="/registre-personnel" element={<RegistrePersonnel />} />
        <Route path="/planning" element={<PlanningPage />} />
        <Route path="/contrats-clients" element={<ContratPage audience="client" />} />
        <Route path="/relevesdheures" element={<RelevesHeuresListe />} />
        <Route path="/RelevesHeures" element={<RelevesHeures />} />
        <Route path="/test-modal-candidat" element={<TestModalCandidat />} />
      </Route>
    </Routes>
  );

}

export default App;
